
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n608Child = []
  var n609Child = []
  var n610Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'display-preview-frame'},{name:'afterCreate', val: this.updatePreviewFrame},{name:'afterUpdate', val: this.updatePreviewFrame}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n610 = h('iframe', props, n610Child)
  n609Child.push(n610)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'preview-container'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n609 = h('div', props, n609Child)
  n608Child.push(n609)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'display-preview'},{name:'class', val: 'is-clickable'},{name:'class', val: 'is-flex'},{name:'class', val: 'is-justify-content-center'},{name:'onclick', val: this.openFull},{name:'role', val: "button"},{name:'tabindex', val: "0"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n608 = h('div', props, n608Child)
  n0Child.push(n608)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  